<template>
  <Teleport to="body">
    <div
      class="tw:fixed tw:inset-0 tw:z-[9999] tw:flex tw:items-center tw:justify-center"
      @click="onBackdropClick"
    >
      <!-- Backdrop (visual only, no pointer events) -->
      <div
        class="tw:absolute tw:inset-0 tw:bg-black/50 tw:transition-opacity tw:pointer-events-none"
        :class="{ 'tw:backdrop-blur-sm': blur }"
      />

      <!-- Modal -->
      <div
        class="tw:relative tw:font-sans tw:bg-surface tw:rounded-xl tw:shadow-2xl tw:flex tw:flex-col tw:overflow-hidden tw:w-[calc(100vw-2rem)] tw:h-[calc(100vh-2rem)] tw:sm:w-[840px] tw:sm:h-[80vh] tw:sm:max-h-[1100px]"
        @click.stop
      >
        <!-- Header -->
        <div class="tw:flex tw:items-center tw:px-content-x tw:pt-3 tw:pb-2">
          <slot name="header-left" />
          <div class="tw:flex-1" />
          <slot name="header-right" />
          <button
            class="tw:w-8 tw:h-8 tw:flex tw:items-center tw:justify-center tw:rounded-lg tw:text-label-quaternary tw:transition-colors tw:hover:bg-surface-raised tw:hover:text-label-tertiary"
            @click="$emit('close')"
          >
            <IconX :size="20" :stroke-width="1.5" />
          </button>
        </div>

        <slot />
      </div>
    </div>
  </Teleport>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted } from "vue";
import { IconX } from "@tabler/icons-vue";

const props = withDefaults(
  defineProps<{
    blur?: boolean;
    dismissable?: boolean;
  }>(),
  {
    blur: true,
    dismissable: true,
  },
);

const emit = defineEmits<{
  close: [];
}>();

function onBackdropClick() {
  if (props.dismissable) {
    emit("close");
  }
}

function onKeydown(e: KeyboardEvent) {
  if (e.key === "Escape" && props.dismissable) {
    e.preventDefault();
    e.stopImmediatePropagation();
    emit("close");
  }
}

onMounted(() => {
  document.addEventListener("keydown", onKeydown);
});

onUnmounted(() => {
  document.removeEventListener("keydown", onKeydown);
});
</script>
